import React, { useState } from "react";
import HotelRounded from "@mui/icons-material/HotelRounded";
import DirectionsWalkRounded from "@mui/icons-material/DirectionsWalkRounded";
import DescriptionRounded from "@mui/icons-material/DescriptionRounded";
import MedicalServicesRounded from "@mui/icons-material/MedicalServicesRounded";
import EncounterSettingMenu, {
  NOTE_FORMAT_OPTIONS,
  encounterSettingLabel,
  noteFormatLabel,
} from "./EncounterSettingMenu";
import OptionRow from "./OptionRow";
import { SPECIALTIES, specialtyLabel } from "./specialties";
import { ENCOUNTER_SETTINGS } from "./inpatient";

/**
 * Specialty, Visit type and (inpatient) Note type, as option rows with their menus. Shared by the
 * Record step and the Events note's Event step, which is that note type's first screen. Omit a
 * change handler to hide its row.
 */
const EncounterSetupRows = ({
  specialty,
  onSpecialtyChange,
  encounterSetting,
  onEncounterSettingChange,
  noteFormat,
  onNoteFormatChange,
  disabled = false,
}) => {
  const [specialtyAnchor, setSpecialtyAnchor] = useState(null);
  const [settingAnchor, setSettingAnchor] = useState(null);
  const [noteFormatAnchor, setNoteFormatAnchor] = useState(null);
  const inpatient = encounterSetting === ENCOUNTER_SETTINGS.INPATIENT;

  return (
    <>
      {onSpecialtyChange && (
        <OptionRow
          icon={<MedicalServicesRounded />}
          label="Specialty"
          value={specialtyLabel(specialty)}
          onClick={(e) => setSpecialtyAnchor(e.currentTarget)}
          disabled={disabled}
          opensMenu
        />
      )}
      {onEncounterSettingChange && (
        <OptionRow
          icon={inpatient ? <HotelRounded /> : <DirectionsWalkRounded />}
          label="Visit type"
          value={encounterSettingLabel(encounterSetting)}
          onClick={(e) => setSettingAnchor(e.currentTarget)}
          disabled={disabled}
          opensMenu
        />
      )}
      {onNoteFormatChange && inpatient && (
        <OptionRow
          icon={<DescriptionRounded />}
          label="Note type"
          value={noteFormatLabel(noteFormat)}
          onClick={(e) => setNoteFormatAnchor(e.currentTarget)}
          disabled={disabled}
          opensMenu
        />
      )}

      {onSpecialtyChange && (
        <EncounterSettingMenu
          anchorEl={specialtyAnchor}
          onClose={() => setSpecialtyAnchor(null)}
          value={specialty}
          onChange={onSpecialtyChange}
          options={SPECIALTIES}
        />
      )}
      {onEncounterSettingChange && (
        <EncounterSettingMenu
          anchorEl={settingAnchor}
          onClose={() => setSettingAnchor(null)}
          value={encounterSetting}
          onChange={onEncounterSettingChange}
        />
      )}
      {onNoteFormatChange && (
        <EncounterSettingMenu
          anchorEl={noteFormatAnchor}
          onClose={() => setNoteFormatAnchor(null)}
          value={noteFormat}
          onChange={onNoteFormatChange}
          options={NOTE_FORMAT_OPTIONS}
        />
      )}
    </>
  );
};

export default EncounterSetupRows;
